export default function VisionXLogo() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_692_25044)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.528 0.000244141H22.472C27.7341 0.000244141 32 4.27411 32 9.54611V21.6474C32 27.3653 27.3735 32.0005 21.6663 32.0005H9.52773C4.26587 32.0002 0 27.7264 0 22.4544V9.54611C0 4.27411 4.26587 0.000244141 9.528 0.000244141Z"
          fill="url(#paint0_linear_692_25044)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7152 25.1428L15.2936 25.1428C14.6246 25.1438 13.976 24.9175 13.458 24.5024L4.28516 17.1428L6.99363 17.1428C7.66249 17.1427 8.31089 17.3689 8.82921 17.7832L14.71 22.5202C15.079 22.7984 15.5314 22.9493 15.9969 22.9493C16.4625 22.9493 16.9149 22.7984 17.2839 22.5202L23.1697 17.793C23.6884 17.3794 24.3365 17.1532 25.0052 17.1526L27.7137 17.1526L18.5483 24.4975C18.0313 24.9124 17.3834 25.1436 16.7152 25.1428Z"
          fill="#F5F6F8"
        />
        <path
          d="M17.144 14.8572C18.4061 14.8572 19.4297 15.8805 19.4297 17.1429H16.2866H14.858C13.5959 17.1429 12.5723 16.1196 12.5723 14.8572H16.2866H17.144Z"
          fill="#F5F6F8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.2848 6.85719L16.7064 6.85719C17.3754 6.85623 18.024 7.08253 18.5419 7.49758L27.7148 14.8572L25.0064 14.8572C24.3375 14.8573 23.6891 14.6311 23.1708 14.2168L17.2899 9.47985C16.921 9.20157 16.4686 9.05069 16.0031 9.05069C15.5375 9.05069 15.0851 9.20157 14.7161 9.47985L8.83032 14.207C8.3116 14.6206 7.66348 14.8468 6.99475 14.8474L4.28627 14.8474L13.4517 7.50245C13.9687 7.08758 14.6166 6.85639 15.2848 6.85719Z"
          fill="#F5F6F8"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_692_25044"
          x1="10.1429"
          y1="28.7684"
          x2="45.5001"
          y2="-9.52312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#001625" />
          <stop offset="0.475249" stopColor="#265EF1" />
          <stop offset="1" stopColor="#8AAAFD" />
        </linearGradient>
        <clipPath id="clip0_692_25044">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
